
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import archivos from './barra-respuestas-archivos.vue';

import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            archivos,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get NuevoMensaje() { return this.Controlador.NuevoMensaje; };
        public get EnviandoMensaje() { return this.NuevoMensaje.EnviandoMensaje; };

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        public Focused: boolean = false;
        public get Respuesta() { return this.NuevoMensaje.Contenido; }
        public set Respuesta( x: string ) { this.NuevoMensaje.Contenido = x; }

        mounted()
        {
            this.Eventos.push( this.Controlador.onScrollYFocus.subscribe( () =>
            {
                this.FocusRespuesta();
            } ) );

        }

        EnviarMensaje()
        {
            if ( this.NuevoMensaje.Valido )
            {
                this.NuevoMensaje.EnviarMensaje();
                this.Controlador.ScrollYFocus();

            }
        }

        FocusRespuesta()
        {
            document.getElementById( 'input-respuesta' ).focus();
        }

    }
